var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step" },
    [
      _c("h2", { staticClass: "group-title" }, [_vm._v("Groups")]),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.form.pricings, function(pricing, index) {
          return _c("camp-pricing-create", {
            key: pricing.id,
            staticClass: "camp-pricing",
            attrs: {
              "pricing-id": pricing.id,
              "pricing-name": pricing.name,
              "pricing-grade-from": pricing.gradeFrom,
              "pricing-grade-to": pricing.gradeTo,
              "pricing-age-from": pricing.ageFrom,
              "pricing-age-to": pricing.ageTo,
              "pricing-time-from": pricing.timeFrom,
              "pricing-time-to": pricing.timeTo,
              "can-remove": _vm.form.pricings.length > 1,
              "form-valid": _vm.formValid
            },
            on: {
              "input:name": function($event) {
                return _vm.setCampPricingName({ name: $event, id: pricing.id })
              },
              "input:time-to": function($event) {
                return _vm.setCampPricingTimeTo({
                  timeTo: $event,
                  id: pricing.id
                })
              },
              "input:time-from": function($event) {
                return _vm.setCampPricingTimeFrom({
                  timeFrom: $event,
                  id: pricing.id
                })
              },
              "input:grade-from": function($event) {
                return _vm.setCampPricingGradeFrom({
                  gradeFrom: $event,
                  id: pricing.id
                })
              },
              "input:grade-to": function($event) {
                return _vm.setCampPricingGradeTo({
                  gradeTo: $event,
                  id: pricing.id
                })
              },
              "input:age-from": function($event) {
                return _vm.setCampPricingAgeFrom({
                  ageFrom: $event,
                  id: pricing.id
                })
              },
              "input:age-to": function($event) {
                return _vm.setCampPricingAgeTo({
                  ageTo: $event,
                  id: pricing.id
                })
              },
              "range-validate": function($event) {
                return _vm.onRangeValidate($event, index)
              },
              click: _vm.addCampPricing,
              remove: function($event) {
                return _vm.removeCampPricing(pricing.id)
              }
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("add-button", { on: { click: _vm.addCampPricing } }, [
        _vm._v("Add another group")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43ae8114", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ae8114","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/Step2.vue
// module id = null
// module chunks = 